import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { UserFilter } from '@/api/DTO/user/userList.interface';

interface Props {
	statusList: { id: string | number; name: string }[];
}
export default function UserListSummaryFilterSection(props: Props) {
	const { statusList } = props;
	const { t } = useTranslation();
	const { control } = useFormContext<UserFilter>();

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={2.5}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='userStatuses'
					label={t('common.userStatus')}
					options={statusList}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
			{/* <Grid item xs={2}>
				<AppDropDownMenu
					control={control}
					name='sorting'
					size='small'
					label={t('user.arrangement')}
					options={arrangementList}
					required
				/>
			</Grid> */}
		</Grid>
	);
}
